import type {ReactElement} from 'react';
import React from 'react';
import {BaseItemBrightnessOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-item-brightness-option';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetSelectedSlideId} from '@Hooks/poster-editor/useGetSelectedSlideId';
import {useGetKeyFromEffectsOfActiveSlideItem} from '@Hooks/poster-editor/useGetKeyFromEffectsOfActiveSlideItem';

export function SlideshowItemBrightnessOption(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeSlideUID = useGetSelectedSlideId();
  const itemBrightness = useGetKeyFromEffectsOfActiveSlideItem('brightness');

  if (!activeItem || !activeSlideUID) {
    throw new Error('Active item or active slide is not defined in slideshow item effects options');
  }

  if (!activeItem.isSlideshow()) {
    throw new Error(`Expected active item to be of type slideshow, got ${activeItem.gitype} instead`);
  }

  if (itemBrightness === undefined) {
    throw new Error('blackandwhite is undefined for active slide item');
  }

  const updateBrightness = (brightness: number, undoable = true): void => {
    void activeItem.updateSlideFromObject(
      activeSlideUID,
      {
        effects: {
          brightness,
        },
      },
      {
        undoable,
      }
    );
  };

  return <BaseItemBrightnessOption brightness={itemBrightness} updateBrightness={updateBrightness} />;
}
